module.exports = __webpack_public_path__ + "static/img/water.748b758.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/water.png
// module id = pRJQ
// module chunks = 0